import React from "react";

type AdSenseProp = {
  client: string;
  slot: string;
  className?: string;
  style?: React.CSSProperties;
  layout?: string;
  layoutKey?: string;
  responsive?: string;
  format?: string;
};

class AdSense extends React.Component<AdSenseProp> {
  componentDidMount() {
    if (window)
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
        {}
      );
  }

  render() {
    return (
      <ins
        className={`${this.props.className} adsbygoogle`}
        style={this.props.style}
        data-ad-client={this.props.client}
        data-ad-slot={this.props.slot}
        data-ad-layout={this.props.layout}
        data-ad-layout-key={this.props.layoutKey}
        data-ad-format={this.props.format}
        data-full-width-responsive={this.props.responsive}
      ></ins>
    );
  }
}

export default AdSense;
